import { VoucherCategoryCreatePage } from '@/features/voucher-category/pages/VoucherCategoryCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/voucher-category/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["voucher_category.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VoucherCategoryCreatePage,
})
